import React, { useEffect } from "react";
import { Modal, Typography, Button, List, Link, Icon } from "@virkesborsen/ui-component-library";
import { ContentContainer, GrowingContainer } from "./utils/utils";

export const PropertyFailedCriteriaStep = ({ currentStepIndex, totalSteps, handleBack, handleNext, handleClose, updateCo2Deal, updateCo2Fired}) => {

  useEffect(() => {
    if (!updateCo2Fired){
      updateCo2Deal({
        stage:"failed",
        comments: "Not arbonics viable"
      })

      gtag("event", "fe_co2_failed" + currentStepIndex.toString(), {
        method: "site"
      });
    }
  }, [])

  return (
    <>
    <Modal.Content>
        <ContentContainer>
          <GrowingContainer className="bg-neutral-stone-100 rounded-3 px-4 py-4 mt-2">
            <Icon color="dark" name="infoFilled" size="xxlarge" />
            <Typography variant="subheaderSmallMedium" className="neutral-pebble">Fastighet uppfyller inte kriterier</Typography>
            <Typography variant="bodySmallRegular" className="neutral-pebble">Din fastighet har tyvärr inte potential för kolkrediter. Detta beror ofta på att skogen inte möter följande krav:</Typography>
            <List 
                items={[
                    'Avverkningsmogen',
                    'Arealen för kolkrediter är minst 5 ha',
                    'Andelen gran är max 35%',
                ]}
            />
            <Typography variant="bodySmallRegular" className="neutral-pebble">Om du har några frågor, vänligen kontakta <Link href="mailto:kolkrediter@treebula.se" underline> kolkrediter@treebula.se.</Link></Typography>
          </GrowingContainer>
        </ContentContainer>
    </Modal.Content>
      <Modal.Footer>
        <Button
          fullWidth
          variant="primary"
          onClick={handleClose}
          label={"Stäng"}
          suffixIcon={"arrowRightSimple"}
        />
      </Modal.Footer>
    </>
  );
};

